import dayjs, { Dayjs } from 'dayjs';
import { PeriodDates, getMonthIndex } from './DashDateSelection';

export const RecentDaysConst = 14;

export function GetDatesForPeriod(period: string): PeriodDates {
  let from: Dayjs = null;
  let to: Dayjs = null;
  switch (period) {
    case 'DEFAULT': {
      from = dayjs().hour(0).minute(0).second(0).millisecond(0).subtract(30, 'day');
      to = dayjs().hour(0).minute(0).second(0).millisecond(0).add(1, 'day');
      break;
    }

    case 'TODAY': {
      from = dayjs().hour(0).minute(0).second(0).millisecond(0).subtract(0, 'day');
      to = dayjs().hour(0).minute(0).second(0).millisecond(0).add(1, 'day');
      break;
    }

    case 'RECENT': {
      from = dayjs().hour(0).minute(0).second(0).millisecond(0).subtract(RecentDaysConst, 'day');
      to = dayjs().hour(0).minute(0).second(0).millisecond(0).add(1, 'day');
      break;
    }

    case 'LAST6MONTHS': {
      from = dayjs().startOf('month').hour(0).minute(0).second(0).millisecond(0).subtract(6, 'month');
      to = dayjs().startOf('month').hour(0).minute(0).second(0).millisecond(0);
      break;
    }

    case 'YESTERDAY': {
      from = dayjs().hour(0).minute(0).second(0).millisecond(0).subtract(1, 'day');
      to = dayjs().hour(0).minute(0).second(0).millisecond(0).add(0, 'day');
      break;
    }

    case 'THISWEEK': {
      from = dayjs().startOf('week').hour(0).minute(0).second(0).millisecond(0);
      to = dayjs().startOf('week').hour(0).minute(0).second(0).millisecond(0).add(1, 'week');
      break;
    }

    case 'LASTWEEK': {
      from = dayjs().startOf('week').hour(0).minute(0).second(0).millisecond(0).subtract(1, 'week');
      to = dayjs().startOf('week').hour(0).minute(0).second(0).millisecond(0);
      break;
    }

    case 'THISMONTH': {
      from = dayjs().startOf('month').hour(0).minute(0).second(0).millisecond(0);
      to = dayjs().startOf('month').hour(0).minute(0).second(0).millisecond(0).add(1, 'month');
      break;
    }

    case 'LASTMONTH': {
      from = dayjs().startOf('month').hour(0).minute(0).second(0).millisecond(0).subtract(1, 'month');
      to = dayjs().startOf('month').hour(0).minute(0).second(0).millisecond(0);
      break;
    }

    default: {
      const arr = period.split('_');
      if (arr.length == 2) {
        const month = getMonthIndex(arr[0]);
        const year = parseInt(arr[1]);

        from = dayjs().month(month).year(year).startOf('month').hour(0).minute(0).second(0).millisecond(0);
        to = dayjs()
          .month(month)
          .year(year)
          .startOf('month')
          .hour(0)
          .minute(0)
          .second(0)
          .millisecond(0)
          .add(1, 'month');
      }

      if (arr.length == 3) {
        const month = getMonthIndex(arr[0]);
        const year = parseInt(arr[1]);
        const day = parseInt(arr[2]);

        from = dayjs().month(month).year(year).date(day).startOf('day').hour(0).minute(0).second(0).millisecond(0);
        to = dayjs()
          .month(month)
          .year(year)
          .date(day)
          .startOf('day')
          .hour(0)
          .minute(0)
          .second(0)
          .millisecond(0)
          .add(1, 'day');
      }
    }
  }

  return {
    fromUnix: from.unix(),
    toUnix: to.unix()
  };
}
